'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib = require('tslib');
var jsxRuntime = require('react/jsx-runtime');
var alloyRowList_module = require('./alloy-row-list.module.scss.js');
var cx = require('classnames');
var withAnalytics = require('../../withAnalytics.js');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var cx__default = /*#__PURE__*/_interopDefault(cx);

var RowList = function (_a) {
    var _b, _c;
    var children = _a.children, justify = _a.justify, className = _a.className; _a.analyticsEvents; var props = tslib.__rest(_a, ["children", "justify", "className", "analyticsEvents"]);
    var rowClassNames = cx__default.default("".concat(alloyRowList_module.default['row-list']), (_b = {},
        _b["".concat(className)] = className,
        _b));
    var containerClassNames = cx__default.default('row', 'flex-nowrap', "".concat(alloyRowList_module.default['row-overflow']), (_c = {},
        _c["justify-content-".concat(justify)] = justify,
        _c["justify-content-start"] = !justify,
        _c));
    return (jsxRuntime.jsx("div", tslib.__assign({ "data-testid": "row-list", className: rowClassNames }, props, { children: jsxRuntime.jsx("div", tslib.__assign({ className: "container" }, { children: jsxRuntime.jsx("div", tslib.__assign({ className: containerClassNames }, { children: children })) })) })));
};
var exportComponent = withAnalytics.withAnalytics(RowList);
exportComponent.displayName = RowList.name;

exports.RowList = RowList;
exports.default = exportComponent;
//# sourceMappingURL=RowList.js.map
